import React from 'react';
import { motion } from 'framer-motion';
import { Card } from './ui/Card';
import { AlertCircle, RefreshCw } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-20 px-4" data-id="element-172">
      <div className="max-w-4xl mx-auto" data-id="element-173">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-174">
          <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-175">
            Here's the Truth Nobody Says Out Loud
          </h2>
          <p className="text-xl text-foreground/80 max-w-2xl mx-auto" data-id="element-176">
            Modern diapers are{' '}
            <strong className="text-primary font-semibold" data-id="element-177">too good</strong>.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} data-id="element-178">
          <Card className="bg-white relative overflow-hidden" data-id="element-179">
            <div className="absolute top-0 left-0 w-2 h-full bg-primary" data-id="element-180"></div>

            <div className="mb-8" data-id="element-181">
              <p className="text-lg text-foreground/80 leading-relaxed" data-id="element-182">
                They keep kids so dry that your child's brain doesn't get a
                strong "wet = uncomfortable" signal... which means there's no
                biological urgency to stop playing and get to the bathroom.
              </p>
            </div>

            <div className="bg-accent/50 rounded-xl p-6 md:p-8 border border-border" data-id="element-183">
              <h3 className="text-xl font-semibold mb-4 flex items-center gap-2" data-id="element-184">
                <AlertCircle className="text-primary w-6 h-6" data-id="element-185" />
                The Frustrating Cycle
              </h3>

              <p className="text-foreground/80 mb-6" data-id="element-186">
                Now combine that with daycare requirements, a work schedule, and
                zero time to "wait until they feel ready," and you get the same
                cycle every week:
              </p>

              <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8 text-center font-medium" data-id="element-187">
                <div className="bg-white p-4 rounded-lg shadow-sm border border-border w-full md:w-auto flex-1" data-id="element-188">
                  You try.
                </div>
                <RefreshCw className="text-muted-foreground w-6 h-6 rotate-90 md:rotate-0 flex-shrink-0" data-id="element-189" />
                <div className="bg-white p-4 rounded-lg shadow-sm border border-border w-full md:w-auto flex-1" data-id="element-190">
                  It gets messy.
                </div>
                <RefreshCw className="text-muted-foreground w-6 h-6 rotate-90 md:rotate-0 flex-shrink-0" data-id="element-191" />
                <div className="bg-white p-4 rounded-lg shadow-sm border border-border w-full md:w-auto flex-1" data-id="element-192">
                  You put the diaper back on "just in case."
                </div>
              </div>

              <p className="text-center mt-8 text-xl font-serif font-semibold text-destructive" data-id="element-193">
                And nothing changes.
              </p>
            </div>
          </Card>
        </motion.div>
      </div>
    </section>;
}